import { type PostMessageParams } from "@cohesive/api-client";
import type { HarnessControl } from "./hooks/useHarnessControl";
import type { PermissionModeControl } from "./hooks/usePermissionModeControl";

export type SendSettings = Pick<
  PostMessageParams,
  "reasoning_effort" | "harness_reasoning_effort" | "permission_mode" | "model"
>;

/**
 * What a message runs on, for every way of sending one — typed, dictated, a suggestion or a quick
 * action — read when it is sent, so none of them starts a chat on something other than what the
 * composer shows.
 */
export function sendSettings(
  harness: Pick<HarnessControl, "getSendSettings">,
  /** Absent where nothing offers a permission pick, which leaves the chat on its default. */
  permission: Pick<PermissionModeControl, "sendPermissionMode"> | undefined,
): SendSettings {
  return {
    ...harness.getSendSettings(),
    permission_mode: permission?.sendPermissionMode,
  };
}

/** The settings a composer stamped on its send params, for a host that posts them itself. */
export function sentSettings(params: PostMessageParams): SendSettings {
  const { reasoning_effort, harness_reasoning_effort, permission_mode, model } =
    params;
  return {
    reasoning_effort,
    harness_reasoning_effort,
    permission_mode,
    ...(model ? { model } : {}),
  };
}
